import React from "react";

interface ButtonProps {
  onClick: () => void;
  label: string;
  type?: "button" | "submit" | "reset";
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  label,
  type = "button",
  className = "w-full py-3 bg-blue-600 text-sm 2xl:text-base text-white rounded-lg hover:bg-blue-500 transition",
}) => {
  return (
    <button onClick={onClick} type={type} className={className}>
      {label}
    </button>
  );
};

export default Button;
